import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import Image from 'next/image';
import styles from './sectionBg.module.scss'
// Import Swiper Use
import { useSwiperSlide } from 'swiper/react';

function SectionBg({data, moveBG, classes}) {
    //console.log(data);
    // Animations
    const swiperSlide = useSwiperSlide();
    // GSAP Split text
    useEffect(() => {  
      gsap.set('.section-bg', {scale: 1.2, opacity: 0});
      gsap.to('.section-bg', {scale:1, opacity: 1, ease:"power.out", duration: 1, delay:0 })
    }, [swiperSlide.isActive]);

  return (
   <>
        <div className={`section-bg ${styles.sectionBG} absolute left-0 top-0 w-full h-full z-10 ${classes}`} >
            <Image 
                className='object-cover object-center w-full h-full' 
                src={data?.bgImage?.src} 
                height={data?.bgImage?.height} 
                width={data?.bgImage?.width}
                blurDataURL={data?.bgImage?.blurDataURL}
                placeholder='blur'
                alt="Section BG" />
        </div>
   </>
  )
}

export default SectionBg